export default "__VITE_ASSET__DWAYWJyj__"